// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__DBE56","icon":"SortAdornment_icon__GINs-","up":"SortAdornment_up__1aNWZ","down":"SortAdornment_down__1UZS7","active":"SortAdornment_active__3-tGr"};